export const getComponentOverviewHeaderKeyList = (t, isMobile = false) => {
  const headers = [
    {
      headerName: t('facility', { ns: 'component' }),
      type: 'text',
      name: 'facility',
      width: 120,
      hide: isMobile,
      flex: 1,
    },
    { headerName: t('position', { ns: 'common' }), paddingRight: 12, type: 'text', name: 'position', width: 120 },
    {
      headerName: t('articleNumber', { ns: 'component' }),
      type: 'text',
      name: 'articleNumber',
      width: 100,
      hide: isMobile,
      flex: 1.5,
    },
    {
      headerName: t('articleName', { ns: 'component' }),
      type: 'text',
      name: 'articleName',
      width: 120,
      hide: isMobile,
      flex: 1.5,
    },
    { headerName: t('quantity', { ns: 'component' }), type: 'text', name: 'quantity', width: 80, flex: 1 },
    {
      headerName: t('batchNumber', { ns: 'component' }),
      type: 'text',
      name: 'batchNumber',
      width: 100,
      flex: 1.2,
    },
    {
      headerName: t('installed', { ns: 'component' }),
      type: 'date',
      name: 'installedDate',
      width: 120,
      flex: 1.2,
    },
    {
      headerName: t('lifespan-left', { ns: 'component' }),
      type: 'text',
      name: 'lifespanLeft',
      width: 120,
      flex: 1.5,
    },
  ]

  return isMobile ? headers.filter(h => !h.hide) : headers
}
